import * as maplibregl from 'maplibre-gl'
import { setWorkerUrl } from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'

setWorkerUrl(`${process.env.PUBLIC_URL}/static/maplibre-gl-worker.mjs`)

export default maplibregl
